const testimonies = [
  { name: 'cappei' },
  { name: 'nykoleras' },
  { name: 'jessicau' },
  { name: 'mahdii' },
  { name: 'christine' },
];

export default testimonies;
